/*
  Added-to-cart panel and quick add for "Completează echipamentul".
  - Venture's AjaxCart dispatches "ams:cart:added" (cancelable) with the line
    item; when #AmsAdded exists we cancel it, fill the panel and open it.
  - [data-ams-kit-add] buttons add one unit of a single-variant product.
  - [data-ams-bundle] adds the product on the page plus the first quick-add
    suggestion of each type (ammo, safe, care...) in one click.
*/
(function () {
  'use strict';

  var panel = document.getElementById('AmsAdded');
  var lastFocus = null;

  function money(cents) {
    if (window.theme && theme.Currency && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function updateHeaderCount(count) {
    var link = document.querySelector('.site-header__cart');
    if (!link) return;
    var badge = link.querySelector('.ams-cart-count');
    if (!badge && count > 0) {
      badge = document.createElement('span');
      badge.className = 'ams-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    if (badge) badge.textContent = count;
    var hidden = link.querySelector('.ams-visually-hidden');
    if (hidden) hidden.textContent = ', ' + count + ' produse';
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        if (panel) {
          var total = panel.querySelector('[data-ams-added-total]');
          var count = panel.querySelector('[data-ams-added-count]');
          if (total) total.textContent = money(cart.total_price);
          if (count) count.textContent = '(' + cart.item_count + (cart.item_count === 1 ? ' produs)' : ' produse)');
        }
        return cart;
      })
      .catch(function () {});
  }

  function fillItem(item) {
    if (!panel || !item) return;
    var img = panel.querySelector('[data-ams-added-img]');
    var name = panel.querySelector('[data-ams-added-name]');
    var variant = panel.querySelector('[data-ams-added-variant]');
    var price = panel.querySelector('[data-ams-added-price]');
    if (img) {
      if (item.image) {
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2');
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }
    if (name) name.textContent = (item.product_title || item.title || '').replace(/^XX\s+/i, '');
    var vt = item.variant_title;
    if (variant) {
      variant.hidden = !vt || vt === 'Default Title';
      variant.textContent = vt || '';
    }
    if (price) price.textContent = item.quantity + ' × ' + money(item.final_price || item.price);
  }

  function open() {
    if (!panel || panel.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ams-added-lock');
    var dialog = panel.querySelector('.ams-added__panel');
    if (dialog) setTimeout(function () { dialog.focus(); }, 50);
  }

  function close() {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ams-added-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (panel) {
    document.addEventListener('ams:cart:added', function (evt) {
      evt.preventDefault();
      fillItem(evt.detail);
      refreshCart();
      open();
    });

    panel.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-ams-added-close]')) close();
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') close();
    });
  }

  // ---------- Bundle: this product + one suggestion of each type ----------
  var bundle = document.querySelector('[data-ams-bundle]');

  function bundleParts() {
    if (!bundle) return null;
    var json = document.getElementById(bundle.getAttribute('data-product-json'));
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!json || !form) return null;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return null; }
    var select = form.querySelector('[name="id"]');
    var variantId = select ? Number(select.value) : 0;
    var variant = null;
    (product.variants || []).forEach(function (v) { if (v.id === variantId) variant = v; });
    if (!variant || !variant.available) return null;

    var seen = {};
    var extras = [];
    bundle.parentNode.querySelectorAll('[data-ams-kit-add]').forEach(function (b) {
      var reason = b.getAttribute('data-reason') || b.getAttribute('data-variant-id');
      if (seen[reason] || b.classList.contains('is-added')) return;
      seen[reason] = true;
      extras.push({ id: Number(b.getAttribute('data-variant-id')), price: Number(b.getAttribute('data-price')) || 0 });
    });
    if (!extras.length) return null;
    var total = variant.price;
    extras.forEach(function (x) { total += x.price; });
    return { main: { id: variant.id, price: variant.price }, extras: extras, total: total };
  }

  function renderBundle() {
    if (!bundle) return;
    var parts = bundleParts();
    if (!parts) { bundle.hidden = true; return; }
    bundle.querySelector('[data-ams-bundle-count]').textContent =
      parts.extras.length === 1 ? '1 produs recomandat' : parts.extras.length + ' produse recomandate';
    bundle.querySelector('[data-ams-bundle-total]').textContent = money(parts.total);
    bundle.hidden = false;
  }

  if (bundle) {
    renderBundle();
    document.addEventListener('change', function (evt) {
      if (evt.target.closest('form[action*="/cart/add"]')) setTimeout(renderBundle, 50);
    });
    bundle.querySelector('[data-ams-bundle-add]').addEventListener('click', function () {
      var parts = bundleParts();
      if (!parts) return;
      var button = this;
      var label = button.textContent;
      button.disabled = true;
      button.textContent = '…';
      var items = [{ id: parts.main.id, quantity: 1 }].concat(parts.extras.map(function (x) { return { id: x.id, quantity: 1 }; }));
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (data) {
          button.textContent = 'Pachet adăugat';
          parts.extras.forEach(function (x) {
            document.querySelectorAll('[data-ams-kit-add][data-variant-id="' + x.id + '"]').forEach(function (b) {
              b.disabled = true;
              b.classList.add('is-added');
              b.textContent = 'Adăugat';
            });
          });
          fillItem(data && data.items ? data.items[0] : null);
          refreshCart();
          open();
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = label;
          // Fall back to the regular add to cart for the main product.
          var submit = document.querySelector('form[action*="/cart/add"] [type="submit"]');
          if (submit) submit.click();
        });
    });
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-ams-kit-add]');
    if (!button || button.disabled) return;
    var id = button.getAttribute('data-variant-id');
    var label = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        // Mark every copy of this product (PDP list and panel list).
        document.querySelectorAll('[data-ams-kit-add][data-variant-id="' + id + '"]').forEach(function (b) {
          b.disabled = true;
          b.classList.add('is-added');
          b.textContent = 'Adăugat';
        });
        // On the cart page the new line has to appear in the list.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        var item = data && data.items ? data.items[0] : null;
        if (typeof renderBundle === 'function') renderBundle();
        if (panel && !panel.classList.contains('is-open')) fillItem(item);
        refreshCart();
        open();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
        window.location.href = button.closest('.ams-kit__item').querySelector('.ams-kit__title').href;
      });
  });
})();
